export const salesConstants = {
  invoiceTypes: { paper: 'Paper', email: 'E-mail' },
  isGeneratedANumber: 'isGeneratedANumber',
};
